<template>
  <div ref="Drawer">
    <a-drawer v-model:open="open" class="custom-class" root-class-name="root-class-name" :closable="false"
      placement="right" :width="'808px'" @after-open-change="afterOpenChange" @close="cancel"
      wrapClassName="drawer-style" :getContainer="() => Drawer">
      <template v-slot:title>
        <div>
          <img :src="require('@/assets/icons/bg_icon.png')" style="width: 25px; vertical-align: bottom" alt="" />

          <span class="ml10 first_title">报告详情</span>
        </div>
      </template>
      <template #extra>
        <div class="back" @click="closeOpen">
          <a-button type="primary">
            <i class="iconfont icon-fanhuiicon mr5"></i>返回
          </a-button>
        </div>
      </template>

      <div class="drawer_content">
        <div class="left_ant_right">
          <div class="left">智能网联车辆车架号或临时行 驶车号牌信息</div>
          <div class="right">{{ form.testCarNum }}</div>
        </div>
        <div class="left_ant_right">
          <div class="left">智能网联车辆类型</div>
          <div class="right">
            {{ getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + form.carType) }}
          </div>
        </div>
        <div class="left_ant_right" style="margin-bottom: 0">
          <div class="left" style="margin-bottom: 24px">道路类型</div>
          <div class="right">
            <a-radio-group :disabled="true" v-model:value="form.category">
              <a-radio v-for="(item, index) in testType" :key="item.id" :value="item.dataCode + ''">{{ item.dataValue }}
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">单车自动驾驶累计里程【km】</div>
          <div class="right">{{ form.carAutoMileage }}</div>
        </div>
        <div class="left_ant_right">
          <div class="left">单车自动驾驶累计时长【h】</div>
          <div class="right">{{ form.carAutoDuration }}</div>
        </div>
        <div class="left_ant_right">
          <div class="left">
            智能网联车辆测试路线是否和 申请主体提交的测试计划一致
          </div>
          <div class="right">
            <a-radio-group :disabled="true" v-model:value="form.isTestRouteConsistent">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="left_ant_right" style="align-items: start">
          <div class="left">特殊场景覆盖</div>
          <div class="right" style="width: 495px">
            <a-checkbox-group :disabled="true" v-model:value="form.specialScene" style="width: 100%">
              <a-checkbox v-for="(item, index) in specialScene" :key="item.id" :value="item.dataCode + ''">
                {{ item.dataValue }}
              </a-checkbox>
            </a-checkbox-group>

            <!-- <a-radio-group :disabled="true" v-model:value="form.specialScene">
              <a-radio v-for="(item, index) in specialScene" :key="item.id" :value="item.dataCode + ''">
                {{ item.dataValue }}
              </a-radio>
            </a-radio-group> -->
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">单车脱离率【km】</div>
          <div class="right">{{ form.carDepartureRate }}</div>
        </div>
        <div class="left_ant_right">
          <div class="left">脱离原因统计</div>
          <div class="right">{{ form.carDepartureReason }}</div>
        </div>
        <div class="left_ant_right">
          <div class="left">单车急刹率【km】</div>
          <div class="right">{{ form.carEmergencyBrakeRate }}</div>
        </div>
        <div class="left_ant_right">
          <div class="left">急刹原因统计</div>
          <div class="right">{{ form.carEmergencyBrakeReason }}</div>
        </div>
        <div class="left_ant_right">
          <div class="left">违法违章情况</div>
          <div class="right">{{ form.carAccidentCondition }}</div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  defineExpose,
  toRaw,
  defineProps,
  defineEmits,
  watch,
} from "vue";
import { cloneDeep, result } from "lodash-es";
import { message } from "ant-design-vue";
import moment from "moment";
import { getSingleTypeValue } from "@/utils/matchDic.js";
import { detail } from "@/api/report/assess.js";

import useUserStore from "@/store/modules/user";
const store = useUserStore();

import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

const dataType = "specialScene";
const dataType2 = "testRoadType";

const Drawer = ref();
const props = defineProps({});

const open = ref(false);
const formRef = ref();

const form = ref({
  carId: "",
  testCarNum: "",
  carType: "",
  category: "public",
  carAutoMileage: "",
  carAutoDuration: "",
  isTestRouteConsistent: 0,
  specialScene: [],
  carDepartureRate: "",
  carDepartureReason: "",
  carEmergencyBrakeRate: "",
  carEmergencyBrakeReason: "",
  carAccidentCondition: "",
});

const specialScene = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType);
      specialScene.value = val[index].children;
      console.log(specialScene.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
const testType = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType2);
      testType.value = val[index].children;
      console.log(testType.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const afterOpenChange = (bool) => {
  console.log("open", bool);
};

const showDrawer = (data) => {
  open.value = true;
  detail({ id: data.id }).then((res) => {
    if (res.code === 200) {
      console.log(res.data);
      res.data.specialScene = res.data.specialScene && res.data.specialScene !== 'null' ? res.data.specialScene.split(',') : []
      form.value = res.data;
      console.log(form.value);
    }
  });
};
const closeOpen = () => {
  open.value = false;
  // formRef.value.resetFields();
};
const cancel = () => {
  console.log("取消");
  open.value = false;
};
// 使用 defineExpose 向外暴露指定的数据和方法
defineExpose({
  showDrawer,
});
</script>
<style lang="less" scoped>
.first_title {
  color: rgba(29, 33, 41, 0.7);
  font-weight: 600;
  font-size: 18px;
}

.drawer_content {
  padding-left: 46px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}

.left_ant_right {
  display: flex;
  align-items: center;
  margin-bottom: 23px;

  .left {
    width: 190px;
    text-align: right;
  }

  .right {
    margin-left: 32px;
  }
}

/deep/.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f2f4f7;
}

/deep/ .ant-drawer .ant-drawer-footer {
  display: flex;
  justify-content: center;
  border-top: 0px;
  margin-bottom: 40px;
}

/deep/ .ant-drawer .ant-drawer-header {
  border-bottom: 0px;
}

/deep/.ant-drawer-title {
  color: rgba(29, 33, 41, 1);
  font-weight: 600;
  font-size: 18px;
}

/deep/.ant-radio-wrapper span.ant-radio+* {
  width: 139px;
}

/deep/.ant-radio-wrapper {
  margin-bottom: 24px;
}

/deep/.ant-checkbox-wrapper {
  width: 130px;
}
</style>
